/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';

import useMaster from 'hook/useMaster';

import { useApi } from '../../../../../libs/data-access/src/api/useApi';
import { TPaginationStatus } from '../../../../../types';
import { PAGINATION_ITEM_LIMIT } from '../../../../../libs/data-access/constant';
import { showToast } from '../../../../../utils/utility';
import { IBookingTypeList } from '../../../../../libs/data-access/types';

export const defaultNewAirlines: IBookingTypeList = {
    name: '',
    code: '',
    flightTicketSupplierId: 0
};

export const useAirlines = () => {

    const {
        postData,
        patchData,
        putData
    } = useApi();

    const {
        supplierList,
        getSupplierList
    } = useMaster();

    const [isLoading, setIsLoading] = useState(false);
    const [isSwitchLoadingIndex, setIsSwitchLoadingIndex] = useState<number>();
    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const [isOpenModalValue, setIsOpenModalValue] = useState<"New" | "Edit" | "Delete" | undefined>(undefined);
    const [searchValue, setSearchValue] = useState("");
    const [airlinesList, setAirlinesList] = useState<IBookingTypeList[]>([]);
    const [selectedAirlines, setSelectedAirlines] = useState<IBookingTypeList | undefined>(undefined);
    const [newAirlines, setNewAirlines] = useState<IBookingTypeList>(defaultNewAirlines);


    useEffect(() => {
        if (searchValue?.length > 2 || searchValue === "") {
            getAirlinesList("INITIAL_PAGE");
        }
        getSupplierList("FLIGHT")
    }, [searchValue])


    // API FUNCTION
    const getAirlinesList = async (paginationAction: TPaginationStatus, id?: number) => {
        setIsLoading(true);
        const response = await postData(`flight-airline/get-all`,
            {
                paginationFilterRequest: {
                    paginationAction: paginationAction,
                    maxLimit: 250, // PAGINATION_ITEM_LIMIT,
                    id: id ?? null,
                    sortingOrder: "DESC"
                },
                search: searchValue ?? "",
            });
        setIsLoading(false);

        if (response.isSuccess) {
            setAirlinesList(response.data.data)
        } else {
            setAirlinesList([])
            showToast({
                type: "error",
                message: response.message ?? "Something went wrong",
            });
        };
    };


    const submitNewAirlines = async () => {
        setIsBtnLoading(true);

        const response = await postData(`flight-airline/create`, newAirlines);

        if (response.isSuccess) {
            showToast({
                type: "success",
                message: "Airline added successfully",
            });
            getAirlinesList("INITIAL_PAGE");
            setIsOpenModalValue(undefined);
            setNewAirlines(defaultNewAirlines);
        } else {
            showToast({
                type: "error",
                message: response.message ?? "Something went wrong",
            });
        };

        setIsBtnLoading(false);
    };

    const UpdateStatus = async (id: number, status: boolean, index: number) => {
        setIsSwitchLoadingIndex(index);

        const response = await patchData(`flight-airline/${status ? "active-all" : "inActive-all"}?ids=${id}`, {});

        if (response.isSuccess) {
            showToast({
                type: "success",
                message: "Airline status updated successfully",
            })
            getAirlinesList("INITIAL_PAGE");
        } else {
            showToast({
                type: "error",
                message: response.message ?? "Something went wrong",
            });
        };

        setIsSwitchLoadingIndex(undefined);
    };

    const UpdateAirline = async (id: number, name: string) => {
        setIsBtnLoading(true);

        const response = await putData(`flight-airline/update`, { ...selectedAirlines, flightTicketSupplierId: selectedAirlines?.supplierId });
        if (response.isSuccess) {
            showToast({
                type: "success",
                message: "Airline updated successfully",
            });
            getAirlinesList("INITIAL_PAGE");
            setSelectedAirlines(undefined);
            setIsOpenModalValue(undefined);
        } else {
            showToast({
                type: "error",
                message: response.message ?? "Something went wrong",
            });
        };
        setIsBtnLoading(false);
    };

    const deleteAirline = async (id: number) => {
        const isConfirm = window.confirm("Are you sure you want to delete this Airline?");
        if (!isConfirm) return;
        else {
            setIsBtnLoading(true);
            showToast({
                type: "success",
                title: "Ready to delete",
                message: "Add api to delete Airline Type"
            })

        }

        // setIsBtnLoading(true);
        // const response = await putData(`flight-airline/delete`, {id: id});
        // if (response.isSuccess) {
        //     showToast({
        //         type: "success",
        //         message: "Airline deleted successfully",
        //     })
        //     getAirlinesList("INITIAL_PAGE");
        //     setSelectedAirlines(undefined);
        // } else {
        //     showToast({
        //         type: "error",
        //         message: response.message ?? "Something went wrong",
        //     })
        // };
        // setIsBtnLoading(false);
    };


    return {
        isLoading,
        isSwitchLoadingIndex,
        isBtnLoading,
        isOpenModalValue,
        setIsOpenModalValue,
        airlinesList,
        searchValue,
        setSearchValue,
        selectedAirlines,
        setSelectedAirlines,
        newAirlines,
        setNewAirlines,
        submitNewAirlines,
        UpdateStatus,
        UpdateAirline,
        deleteAirline,
        supplierList
    };

}